import { render } from "./WebManager.vue?vue&type=template&id=c0d297b0"
import script from "./WebManager.vue?vue&type=script&lang=js"
export * from "./WebManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__